// @flow
import React from "react";

type Props = {
    text: string,
    url: string,
    tooltip?: string,
    is_active: boolean,
};

const SimpleLink = (props: Props) => {
    if (props.is_active) {
        const className = `active`;
        return (
            <a className={className} href={props.url} title={props.tooltip}>
                {props.text}
            </a>
        );
    } else {
        const className = "";
        return (
            <a className={className} href={""} title={props.tooltip}>
                {props.text}
            </a>
        );
    }
};

export default SimpleLink;
